export enum MainIBSchemeEnum {
  DEFAULT,
  MULTI_TIER,
}
